import styled, {createGlobalStyle, keyframes} from 'styled-components';
import {dFlexColumn, dFlexCenter, alignCenter} from '../../globalVariables/GlobalFlex';
import TickchakLogo from '../../assets/icons/TickchakLogo';
import {getBackground} from '../realtime/utils/themeUtils';

export const liveFont = createGlobalStyle`
    [data-theme='live'] * {
        font-family: var(--font-family-primary);
    }
`;

const twinkle = keyframes`
    0%, 100% { opacity: 0.15; }
    50% { opacity: 1; }
`;

export const stage = styled.div<{$colors?: string[]}>`
    --stage-bg: #1a1a19;
    position: relative;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    overflow: hidden;
    background: ${p => {
    const colors = p.$colors?.slice(1, 3);
    if(!colors?.length) return 'var(--stage-bg)';
    colors.push(getBackground(false));
    const length = colors.length;
    return `linear-gradient(180deg, ${colors.map((color, index) => `${color} ${index * (100 / (length - 1))}%`).join(', ')})`;
}};
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-lg);
    padding-top: calc(var(--space-md) + env(safe-area-inset-top));
    padding-bottom: calc(var(--space-md) + env(safe-area-inset-bottom));
`;

export const starLayer = styled.div`
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background-repeat: repeat;
    animation: ${twinkle} 2.8s ease-in-out infinite;

    &.l1 {
        background-image:
            radial-gradient(2.5px 2.5px at 30px 40px, #fff, transparent),
            radial-gradient(2px 2px at 70px 110px, rgba(255, 255, 255, 0.9), transparent),
            radial-gradient(1.5px 1.5px at 100px 20px, rgba(255, 255, 255, 0.85), transparent),
            radial-gradient(1.5px 1.5px at 140px 70px, rgba(255, 255, 255, 0.75), transparent),
            radial-gradient(1.5px 1.5px at 170px 160px, rgba(255, 255, 255, 0.8), transparent);
        background-size: 200px 200px;
    }
    &.l2 {
        background-image:
            radial-gradient(2.5px 2.5px at 150px 80px, #fff, transparent),
            radial-gradient(2px 2px at 40px 170px, rgba(255, 255, 255, 0.9), transparent),
            radial-gradient(1.5px 1.5px at 200px 40px, rgba(255, 255, 255, 0.75), transparent),
            radial-gradient(1.5px 1.5px at 90px 60px, rgba(255, 255, 255, 0.8), transparent),
            radial-gradient(1.5px 1.5px at 120px 210px, rgba(255, 255, 255, 0.7), transparent);
        background-size: 230px 230px;
        animation-delay: -0.93s;
    }
    &.l3 {
        background-image:
            radial-gradient(2.5px 2.5px at 120px 150px, #fff, transparent),
            radial-gradient(2px 2px at 230px 60px, rgba(255, 255, 255, 0.9), transparent),
            radial-gradient(1.5px 1.5px at 30px 90px, rgba(255, 255, 255, 0.75), transparent),
            radial-gradient(1.5px 1.5px at 180px 220px, rgba(255, 255, 255, 0.8), transparent),
            radial-gradient(1.5px 1.5px at 70px 235px, rgba(255, 255, 255, 0.7), transparent);
        background-size: 260px 260px;
        animation-delay: -1.87s;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
        opacity: 0.7;
    }
`;

export const top = styled.div`
    ${dFlexCenter};
    padding: var(--space-lg);
    font-size: var(--font-size-h3);
    font-weight: var(--font-weight-bold);
`;

export const brandHeader = styled.div`
    ${dFlexCenter};
    padding: var(--space-lg) var(--space-sm);
    background: var(--primitive-black-05);
`;

export const brandLogo = styled(TickchakLogo)`
    height: 42px;
    width: auto;
    display: block;
`;
